<div class="flex flex-wrap items-end gap-3">

    <!-- Calendario range inline -->
    <ngb-datepicker #dp
        (dateSelect)="onDateSelection($event)"
        [displayMonths]="2"
        [dayTemplate]="t"
        outsideDays="hidden" />

    <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = $any(null)">
            {{ date.day }}
        </span>
    </ng-template>

    <!-- Conferma periodo -->
    <button type="button"
            (click)="scegliPeriodo(fromDate, toDate)"
            class="inline-flex h-9 items-center gap-1.5 rounded-full bg-brand-600 px-4 text-[13px] font-bold text-white shadow-sm transition-all hover:bg-brand-700 active:scale-95 focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-1">
        <i class="fas fa-check text-[11px]"></i> Conferma periodo
    </button>

</div>
